<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands =
          [{
            "num_cand": "U2FsdGVkX19lxzxoJJ1yJNOMIhayqPf4k+0gY8Dy5Fk=",
            "cpf": "U2FsdGVkX1+KxBdh2XzZCaVjTm4LHV86fzBf/LWuvTs="
          }, {
            "num_cand": "U2FsdGVkX1+1Fx/twc0/6LzXwu/LUNxJ3dLxxe7Msm8=",
            "cpf": "U2FsdGVkX1/Ji45bYo9/rV71YDmm9cV0SELaKqElAsY="
          }, {
            "num_cand": "U2FsdGVkX1/kKEh1RzUGWdp50FgA5TWEEt2r8r1mEU8=",
            "cpf": "U2FsdGVkX18xDFF8qNxl5H2izqUgaKMCRROPE7N3o2k="
          }, {
            "num_cand": "U2FsdGVkX1/KqFlHLc4JAZ3k3T8UXkqWaDqJAS6rWZw=",
            "cpf": "U2FsdGVkX18ZSK4ZZbYo8/ts9dv2hVl4rMqThwFxBuw="
          }, {
            "num_cand": "U2FsdGVkX1/8FVLMr5qs0gi2pLdEk6qc+Hv5E/JsNAA=",
            "cpf": "U2FsdGVkX196fjhCbkajHNumtaX7OUazfuzKt6lz1xo="
          }, {
            "num_cand": "U2FsdGVkX1/sWSSe/V0y3nAQR6R6+EEibL/lkOmRO3o=",
            "cpf": "U2FsdGVkX1+BmOvv+o+/air/IkNJMtnI8FOTSPOAgaU="
          }, {
            "num_cand": "U2FsdGVkX18+A8AOALCniC9DIpc8d/z1Q9F2VIG9YFA=",
            "cpf": "U2FsdGVkX198+vQYciOzxPmdXEi6+QXxtsrhatFm+68="
          }, {
            "num_cand": "U2FsdGVkX19NwAR+OB2A8xcGOgwCV4XjLEJXAh/Ah7I=",
            "cpf": "U2FsdGVkX1+RhSJzd6Gv9uqgLb+kkm03PHRXt3wQOrA="
          }, {
            "num_cand": "U2FsdGVkX1/Kt81I3O05jhRz53LG7ZfOpxYfUipkTQQ=",
            "cpf": "U2FsdGVkX18Nr+fFDDUpQTzIStDinq6cW8xt/cLZV1A="
          }, {
            "num_cand": "U2FsdGVkX1/DgA5REURDCiua21DOKf4kBqp8sBVSiEY=",
            "cpf": "U2FsdGVkX1/h8wTLtkai9DgzRYUM/Px+xgQJoibhU0M="
          }, {
            "num_cand": "U2FsdGVkX1+meEE7byXArLdrHQ29nMa2MZQEhLYuxcQ=",
            "cpf": "U2FsdGVkX19nOwIym2kglkFZakEmvqN9Sg7TtsKAMiQ="
          }, {
            "num_cand": "U2FsdGVkX19Ogr9W7UtehF8BrzthNd93SDRhEmvuD6A=",
            "cpf": "U2FsdGVkX1/1Su0khMcOK1MHy8x/9m0pRffouJdPh2Q="
          }, {
            "num_cand": "U2FsdGVkX19ldez9ZItkf4LXk/l7z3uKiA+7fjDoUqc=",
            "cpf": "U2FsdGVkX1+JHWVl6UwWPE/yno82B8TsLLcB7kEKrws="
          }, {
            "num_cand": "U2FsdGVkX1+VCuapTJ4AVuxYs+rjYfr4SqzgdOFgzTs=",
            "cpf": "U2FsdGVkX1+pPgY9w2GYL9x4vH5cDTJ3o6hV+CmKcOk="
          }, {
            "num_cand": "U2FsdGVkX1+Vlumv2iUXw/l/QVTk5A0oBVUFKolTp84=",
            "cpf": "U2FsdGVkX19tApAEqm2m7r6IuhKiOyFWnxa9OZElDlA="
          }, {
            "num_cand": "U2FsdGVkX18CYR5zvD1v6Yp/FQIWErh7a9N1cLkgeuk=",
            "cpf": "U2FsdGVkX19Bk1+u+fvdMJ0jwv2mhUu5lb1q2rn5SyA="
          }, {
            "num_cand": "U2FsdGVkX1/h4RabU/FB/eR6n2/nI00BLbsKLwuyq6s=",
            "cpf": "U2FsdGVkX1+JYNy7MPxQp1KfaeFDMLVH2ITmt7ph8SI="
          }, {
            "num_cand": "U2FsdGVkX1/fcRmEFGlngaur5e/rjx5BD3qonF6aVf8=",
            "cpf": "U2FsdGVkX1/+8khguXmRR3a79coUSP2gWKm3rsZuAxI="
          }, {
            "num_cand": "U2FsdGVkX19fHbW4qKgq0oveVjT79pU0hPUftvE+R80=",
            "cpf": "U2FsdGVkX1/KAuVkMyQ+ywDAKLDqqqH7Ghc09V2um1I="
          }, {
            "num_cand": "U2FsdGVkX19T9oyK1eAkou4xBu69LkCK+cALQZhIlFs=",
            "cpf": "U2FsdGVkX188ENjg07ni1AuHSu7LSMsa/NRInm/FQ10="
          }, {
            "num_cand": "U2FsdGVkX1/RvtinDMCLNr9FZpHgiP9c+jJY0kFBYkA=",
            "cpf": "U2FsdGVkX18l9wuJRqq6V9t7ogLax1i03Na1yJMX8Gk="
          }, {
            "num_cand": "U2FsdGVkX1/QeC5hjo17SAJnUWKJXFfXa65gC4FpMuU=",
            "cpf": "U2FsdGVkX1++bcai9mlCEvtHlBwN8iFEltOhINUqY2I="
          }, {
            "num_cand": "U2FsdGVkX1+O71+Gj0dqm38p7Djksj68VkHB6Qqdr1s=",
            "cpf": "U2FsdGVkX1/hEYhBGK5XvoQUJbpOb0yihoiVpSIAwUI="
          }, {
            "num_cand": "U2FsdGVkX1+Nfwi565EHxJA3uwlCnYe0jerOHMuPJrc=",
            "cpf": "U2FsdGVkX1/C34ShGw8vOwRCPqa56J6R/u0y9h+09O8="
          }, {
            "num_cand": "U2FsdGVkX19VE9mE0pSqkzQ43TRz4M4CaspTx3CV0ss=",
            "cpf": "U2FsdGVkX193NmXRIjjeBqSX6WrFD8x4XRB6/FF6ddM="
          }, {
            "num_cand": "U2FsdGVkX19BebIUQqCGj3tJU1UzaTOENvC+jtvUHnM=",
            "cpf": "U2FsdGVkX19yuMZOTuD4eHV2eofnLxDA1uVajzHOfcc="
          }, {
            "num_cand": "U2FsdGVkX192NsQp67HS2AHfOFIBZ1kT6AGfFs2ANLI=",
            "cpf": "U2FsdGVkX1/c0KmGbZbzyr5CzSONm/2/leIcdXxlvrY="
          }, {
            "num_cand": "U2FsdGVkX1/RhlNcAZEBAJRShPjeYx6UQjH80PbviAE=",
            "cpf": "U2FsdGVkX1+HBqAejNSHKCY4jMBgj25t09nW47gHgv0="
          }, {
            "num_cand": "U2FsdGVkX18DbkRR9/1lDcpkH/1FqnwRysv3QB5tUp0=",
            "cpf": "U2FsdGVkX18LsH2O55C2moyf7xzF6Noddx3wRNwfZIM="
          }, {
            "num_cand": "U2FsdGVkX19O+w/qhkR2ErofRlfg7WdQI4cmLXBf/mU=",
            "cpf": "U2FsdGVkX1/M1N8Kvd0RYGnLswJYudxip8Ml/ao/O8A="
          }, {
            "num_cand": "U2FsdGVkX1/CIYR8EC4MJn83JxKsZdamcGYyHrRsBwk=",
            "cpf": "U2FsdGVkX19PWJvBhmoKFtqI/onXi1KC5+hnuE7np5g="
          }, {
            "num_cand": "U2FsdGVkX188VoATOIB1X4UH7/dQhNT1q9i/fFrgfnc=",
            "cpf": "U2FsdGVkX19dN2+kCeNMSUbX/Mr3RKPVIm2gvEyFGrI="
          }, {
            "num_cand": "U2FsdGVkX1++Qa4ZZi8HJynHZYrPCCXrsvG7cY3iryw=",
            "cpf": "U2FsdGVkX19g+32cXTGnzgH1VvRU1A7mZuwU2/yuwNc="
          }, {
            "num_cand": "U2FsdGVkX18kRZYxqUPoGkitnDwEJAoXEpCMp5ZSQmA=",
            "cpf": "U2FsdGVkX19oKpIJkLcAlIojKQVtyks7BD9oRPYIajY="
          }, {
            "num_cand": "U2FsdGVkX1/kZ1murqc2Vm0kvZQnHbtAUfmYyhuRXgY=",
            "cpf": "U2FsdGVkX19P8cosRu5eAk8GbnSW1vdmQFgjEt0ZYFI="
          }, {
            "num_cand": "U2FsdGVkX183ioYupzNBYlev3lMuESTHw+1nJlKRl3k=",
            "cpf": "U2FsdGVkX19Ou7N08Gip0lTgxOH1H59t68fJSElRVv4="
          }, {
            "num_cand": "U2FsdGVkX1+A5wT7tGct5AgNnNtbhCqck4fXiVwrjvo=",
            "cpf": "U2FsdGVkX19UnQ5qiU/kMf9VzDT5IKgSmSeAY8ZAL7s="
          }, {
            "num_cand": "U2FsdGVkX1+Pslb1B07IVq4ixsF+NicqwKTQzJQTshE=",
            "cpf": "U2FsdGVkX19TvNopnKVNqojiFFpzFEzjt4lQAQKvj6U="
          }, {
            "num_cand": "U2FsdGVkX18u49kaA8uLguf4umyVzCCvvi5MNTFzwe4=",
            "cpf": "U2FsdGVkX18DJ/LG1lAgbrGcmVTNT8Gt3m9XNEC+VqA="
          }, {
            "num_cand": "U2FsdGVkX1+i1SQW1+2PRFRzppsdWO5kPFJZj5ET8A0=",
            "cpf": "U2FsdGVkX1+x81IpL5BzjxSMQfZnDpnuamVbJ1MSeqA="
          }, {
            "num_cand": "U2FsdGVkX19BksITyYwCycjS6QTBQplJBMlQbpU5mUY=",
            "cpf": "U2FsdGVkX1/zrpLDK3QBfG0YDHaER4InR+2g0qbE9v8="
          }, {
            "num_cand": "U2FsdGVkX18OgYqFpKoPP4FrOSDn+8goJjl8VJCPh/M=",
            "cpf": "U2FsdGVkX18FKlc6zSPS5D1yAzwKgQ3tmlnD0HAidyg="
          }, {
            "num_cand": "U2FsdGVkX1+iKkiQ4VDlaBjtMtSEwlLGiuph6Oyqb48=",
            "cpf": "U2FsdGVkX1/Pqb4UEBrXicPDiPG9L3MU6SU75EW+WUE="
          }, {
            "num_cand": "U2FsdGVkX1/a6XdMklQ3GvjnDkpeT6BLk+8GpNU8zuM=",
            "cpf": "U2FsdGVkX1/AtpnVnVkwpibjCxwxc/w6DC+G+VBkPBQ="
          }, {
            "num_cand": "U2FsdGVkX1+7Ak8Hiqv5dm1tlbUIW+0H255JN3TLdTo=",
            "cpf": "U2FsdGVkX1/HEm0ngk75mdNG6svonkUhPBQa+K9rUaE="
          }, {
            "num_cand": "U2FsdGVkX18W22scefaXklT7r4gq13x8b+Hprnqjao8=",
            "cpf": "U2FsdGVkX19nER6D4OyKtZieh09BST+HiOvV+uz8EmA="
          }, {
            "num_cand": "U2FsdGVkX18wrZAkK7vxeHiIIY7q8UCCpHmv+B9Wo0A=",
            "cpf": "U2FsdGVkX18wOrtyv5zHv4RAxt6Dka3JZDrGbpRb7y8="
          }, {
            "num_cand": "U2FsdGVkX1+/myAtO5poWfzXi/xFRNvXSCjBYUEBb5Y=",
            "cpf": "U2FsdGVkX18tvtHFhqQ4nfCwBZVJ6pQ8oZ2eaK4eufU="
          }, {
            "num_cand": "U2FsdGVkX19BENmTBen9wiR4EJr18AS8vxSZ7fD92x8=",
            "cpf": "U2FsdGVkX19aXLB/Ig4CQChUDEB1EFUnUFC6iysMarY="
          }, {
            "num_cand": "U2FsdGVkX19lgPImdVC3Nrp2iSBIsFpU4drhaXRO0ds=",
            "cpf": "U2FsdGVkX19osQal1FeYHGSYL9gjf/WZDPv97x5Cfso="
          }, {
            "num_cand": "U2FsdGVkX1+1jg/wHyzSYpkG+TJkfd4GSjM9751L2FQ=",
            "cpf": "U2FsdGVkX18dTDCjrbJ/d5mHRnpCsYrybW23YfNHNiA="
          }, {
            "num_cand": "U2FsdGVkX19dKqyisPbOUTYWI/B7ZjN7hp+LtvoEw3w=",
            "cpf": "U2FsdGVkX19JqBOZP7XMyh+qPHFa0T3RnlZoHFAUUkU="
          }, {
            "num_cand": "U2FsdGVkX18gK7QRV3CNMZp/gK19QYRRzhvKHsvLTQw=",
            "cpf": "U2FsdGVkX19lxlDMkogczbqtmdXqS22ylTRu3WfEBtM="
          }, {
            "num_cand": "U2FsdGVkX1+EMuDnffzgv3pcSLID+v20tH924fgSjhw=",
            "cpf": "U2FsdGVkX1+8OAoYCoMo0hHZinRNzdCvBtmFDbRP+uI="
          }, {
            "num_cand": "U2FsdGVkX1/LkT0hhXbmClXjWrf4f/U9BfNWBUSJnfU=",
            "cpf": "U2FsdGVkX1+RU314Cu6PUO4TXJ6fx+1EG+507DWb5mQ="
          }, {
            "num_cand": "U2FsdGVkX1/agLkCDfnX9zvrMkK3Ku2u6rraD6QRkJc=",
            "cpf": "U2FsdGVkX1+iSpXSIOJSZWK/rRHbpLTYnfi6JcZC/t4="
          }, {
            "num_cand": "U2FsdGVkX1+Tk6Cjk/dNxvutWhIDRJwueL4+dRz0ql8=",
            "cpf": "U2FsdGVkX1+WSGAY5MO3WNkUQr5A/QPGcmTX8bsC6hQ="
          }, {
            "num_cand": "U2FsdGVkX18GhV0YTsPeOyafxJaTHgrQf6qy4JZ9VTU=",
            "cpf": "U2FsdGVkX193Aa+x6NAopZyWbEXx6mEMcqyHgQkhnvU="
          }, {
            "num_cand": "U2FsdGVkX1/xAUJPtFLeWN8Logt5DaNsBur+JsUAJlo=",
            "cpf": "U2FsdGVkX1/adjPtCqZ3RZuWjk5RHdtk1flg4uK767M="
          }, {
            "num_cand": "U2FsdGVkX1+CnEQDtdBQrtYvg27OX4OGhW1ZP/OL0/c=",
            "cpf": "U2FsdGVkX1/u0mDqYCsMK4ULQVHhF67bE3VX19MKkpc="
          }, {
            "num_cand": "U2FsdGVkX1/tg/JzHXi9w1fbu7x6nrhe/cNdI33h11s=",
            "cpf": "U2FsdGVkX18Hcq+EA9zL9Uemq3kLTj6nPuMtbhJ8Pkw="
          }, {
            "num_cand": "U2FsdGVkX18MsrZ6rwh09H1KyJUHDKayGhVxmtP6mmg=",
            "cpf": "U2FsdGVkX19KFXylE5KKWB5SMOgjikcwyaEYPXejKiU="
          }, {
            "num_cand": "U2FsdGVkX1/WMLjLxP5zu+TqiRW7f2Mm5YmTv6r6mxE=",
            "cpf": "U2FsdGVkX18t0Dlj4ZhgqT1P8hEfaOwb285hPCLeF4k="
          }, {
            "num_cand": "U2FsdGVkX1+zQSlHerce4sM0c56KU82AnVMJQdNYQ80=",
            "cpf": "U2FsdGVkX1/isxoMXKil8r3C5caQMrqjtdFRulQnvkU="
          }, {
            "num_cand": "U2FsdGVkX19HCUXukMZHJ9sN2EdkHTerYoSGKclmAfI=",
            "cpf": "U2FsdGVkX1/Ujp+wvyCDeVK90objmQkd00fWkgWBjvA="
          }, {
            "num_cand": "U2FsdGVkX1/TAq7roocDRYbzw6xuRMVuL8vjRx2M0SY=",
            "cpf": "U2FsdGVkX18vSg8G7J/HKdMTZIewv+lebTgAe+Ltmto="
          }, {
            "num_cand": "U2FsdGVkX19dug21seEZ0bzlrIMN/BnN5qnmaVFlC/o=",
            "cpf": "U2FsdGVkX1/gjt3rw8otb3sZN/ZmC3ZqBMLE8W2sZ9A="
          }, {
            "num_cand": "U2FsdGVkX19+ka1xFooXEw6Awhn/HESHyTwShonBcc8=",
            "cpf": "U2FsdGVkX1+TxXFjQKGdaeCaVCqoRtG8oSZo+1uyOGk="
          }, {
            "num_cand": "U2FsdGVkX1/vihOLAqrwNN1kyBIjfsVbd/0riW8bO+s=",
            "cpf": "U2FsdGVkX1/rfrx4MgtePZvMsaNObfCDSz8yZXm95+E="
          }, {
            "num_cand": "U2FsdGVkX194us3PyBqUReiZ04iKJNEB0UAKvZ+fewM=",
            "cpf": "U2FsdGVkX1+ixWipkw5M/raAM9bVvkr+cWuLnv455Oc="
          }, {
            "num_cand": "U2FsdGVkX182Km5Imzx8DpWNJlN3EkWNY/QBBMPju3I=",
            "cpf": "U2FsdGVkX18LRTSNMS9FhapXQoM1nU4TFPiuF0MO5fw="
          }, {
            "num_cand": "U2FsdGVkX19PQM9Lgd1XC+HwFAjcqe3Eyc6bOEkMQpw=",
            "cpf": "U2FsdGVkX18cTwtQltsai2H4/8PdRqNXEFJwMzi9Ai4="
          }, {
            "num_cand": "U2FsdGVkX1+hRedYCEjpyc82x83wC9JX2EP4++vTlrc=",
            "cpf": "U2FsdGVkX19SGUI8n9cE1ctp+/mQP21xJrMhLretHS8="
          }, {
            "num_cand": "U2FsdGVkX19uPNp5jtXSUR25oRo+wrKXwEaUADDRJdI=",
            "cpf": "U2FsdGVkX18swnIVvii8DFfAtHbrO2nR9y17tMhkjuo="
          }, {
            "num_cand": "U2FsdGVkX1+1Sz/0kccz8Q6XNGv6z1WnwbYMt/4aGbE=",
            "cpf": "U2FsdGVkX1+/c6jmQvMd+9SgTZkdVPN9zQG/KSDBYqY="
          }, {
            "num_cand": "U2FsdGVkX18IADZYQ/vkSE67a8TLf3VDVvc4tyhsaEA=",
            "cpf": "U2FsdGVkX1+S26NlGdSp6BKH29VAdFNNA8hsYShEVJw="
          }, {
            "num_cand": "U2FsdGVkX18XROzFkbs0vNtMx+pnvp468TMD7gwhG5U=",
            "cpf": "U2FsdGVkX18NVLaGJBrgiMtTCB3xRbX3cGf9Uzo84eg="
          }, {
            "num_cand": "U2FsdGVkX1/dbxjwmo2ciR+Bsv5reW1XlmrX29uTpXc=",
            "cpf": "U2FsdGVkX19sTAReC1IQO8PN3PDYr44oEWr2c1Mohto="
          }, {
            "num_cand": "U2FsdGVkX18nJcRejvm3KC6jrsalICr5e2e1GtjG7f8=",
            "cpf": "U2FsdGVkX1/hY6SqcPEt25tdJQxtvmKtKS/a8hVQjdc="
          }, {
            "num_cand": "U2FsdGVkX1+Q5X/PapjqCxqhIBAYqfBbciR/5H7kIUI=",
            "cpf": "U2FsdGVkX1+Cgwg/IpPwMO+jWWWpZ5YLl7MQBckNWCg="
          }, {
            "num_cand": "U2FsdGVkX19JwJMzp6QfPel3oEqZ2LU0QQ/b5syGbJQ=",
            "cpf": "U2FsdGVkX1+oDM5EmXlSMomLSs9PUh/wtvEq3s3ujwo="
          }, {
            "num_cand": "U2FsdGVkX1+TIuviZcXPaBkyIhHqcnlFSrrPDML0GWM=",
            "cpf": "U2FsdGVkX18cE+SpYe3OEINaQFHwPy3S1M/q1WrS7hs="
          }, {
            "num_cand": "U2FsdGVkX19hzDTIPeKzjCLz3rnOYEZVUZUNHFJiPjU=",
            "cpf": "U2FsdGVkX18nVzTMHFNDLYPMQNfUCXfgBWoBSq8kweE="
          }, {
            "num_cand": "U2FsdGVkX1+VJsykqyZsRXZx4h2Ox8JEa7ieF9UCZIs=",
            "cpf": "U2FsdGVkX18EEOJH3e/Q3bf2ebARhfuCrVPkT5NbxNM="
          }, {
            "num_cand": "U2FsdGVkX1+8k/eE4PDMTa9zb/kB6eVPHaSu9MFKSdE=",
            "cpf": "U2FsdGVkX1+WijbnKzFhcyMi0o2v4AZm7J7Le+5PViY="
          }, {
            "num_cand": "U2FsdGVkX18TNrgwKPSgm8RxW4wCOGIht/P2Q/saaaI=",
            "cpf": "U2FsdGVkX1+uJvRlUEugI1a+zFjGCXwjVw3x3aVc1uE="
          }, {
            "num_cand": "U2FsdGVkX19kJne4RFcwizo2cycEb1AF/fwLmkHT9yQ=",
            "cpf": "U2FsdGVkX18fObwgIBQkoUIcc58P2WnAPqBObSctmzo="
          }, {
            "num_cand": "U2FsdGVkX1+VRHUcMYXtzRrkzm0E+go6N1thiXk9LOY=",
            "cpf": "U2FsdGVkX18244gzPX9UwTmoAGLoyJYPImDPXnpzUVE="
          }, {
            "num_cand": "U2FsdGVkX18HSmT9C7GtICIKNMhbEpqVTj3aPmgQPHw=",
            "cpf": "U2FsdGVkX195YmNGqZgpd92ZkbibkWOAw+ZPyhrrDpA="
          }, {
            "num_cand": "U2FsdGVkX18nJE4Vkqswo39S8bGmPFn4hdVGhseF9k4=",
            "cpf": "U2FsdGVkX18FeyL/dQubJhYjzrtM0NRNlBu6EC0egn0="
          }, {
            "num_cand": "U2FsdGVkX19ZYliC7Dt4khDPGc1ZpoHT3K3GAIUMgkc=",
            "cpf": "U2FsdGVkX1+ek77ErQfjhyNa+E+Fw9hFi3sWQHNWYUk="
          }, {
            "num_cand": "U2FsdGVkX19cTGjmlgqAKJQBqns4forKMEfD9UIDkGI=",
            "cpf": "U2FsdGVkX1/BnIsKVLInHkNpBypvqa6iZk/JuHo+vRo="
          }, {
            "num_cand": "U2FsdGVkX18ZXZ0t8R0cLXhy1FSSsCy2s+4XJ36BZDg=",
            "cpf": "U2FsdGVkX1+fGU0fqTgrVxbiRxstz67TguTbpRS6geY="
          }, {
            "num_cand": "U2FsdGVkX181uKuZiK6mkbPJJvp+JW2X0vjKtGJf9G0=",
            "cpf": "U2FsdGVkX19JmyVdK6k5aiBsb3VJlGv7tId3VF9ZBo8="
          }, {
            "num_cand": "U2FsdGVkX1++r7X4CiG5EmFovihyT7ZIBKeapSXqkjY=",
            "cpf": "U2FsdGVkX18UKgS45qSJ7oCtR0T5Rz0kIIFUZgbMUR4="
          }, {
            "num_cand": "U2FsdGVkX1+KuPSdhQsA8JQ91CgntrvSr7JPHrJ85w8=",
            "cpf": "U2FsdGVkX18YfM6xn2k8rO8PRXi/5Uo6Gg3kuxMTuuQ="
          }, {
            "num_cand": "U2FsdGVkX18h5SplKwMCRqK9nffV6edltyRHKP3xYSU=",
            "cpf": "U2FsdGVkX191qB9zultabBtuaBVe5rVRrBE9OJxut4E="
          }, {
            "num_cand": "U2FsdGVkX1+YOC1g6907T60LXQeZ2MeTcL6SdJBh9Vc=",
            "cpf": "U2FsdGVkX19moMegVb7eqVrbp8AtJqRMMtSwmOAlDSc="
          }, {
            "num_cand": "U2FsdGVkX18A9yJ7FGzr6tTKsUYrCUsVdMnV7UP8J4c=",
            "cpf": "U2FsdGVkX1/jyRBLC3gdetwGvkNGQApQukQFQHlbXdw="
          }, {
            "num_cand": "U2FsdGVkX181dGdW8phNwWoH60lopke58GsTbdCW+x8=",
            "cpf": "U2FsdGVkX197cKdV2aXjtaYlzsBb6xMDWK4cnpQ2v7U="
          }, {
            "num_cand": "U2FsdGVkX19+ffiEjYlZ7KuiSpA3n5vJkSUVvkhvvxM=",
            "cpf": "U2FsdGVkX1+lL4QnC8N2PhkLz2z8aWyC82cqpn9f0Gs="
          }, {
            "num_cand": "U2FsdGVkX1+KH8C/wUMqQQ2nCYjnIN9EflIvSNAk3Cg=",
            "cpf": "U2FsdGVkX19N/v9ZwSLGO5Ga68f2peACPlzJquai0cU="
          }, {
            "num_cand": "U2FsdGVkX1/g/BGoBjYzE1CCnrZwnNuAdAMVQVhySmk=",
            "cpf": "U2FsdGVkX198gLsvcjP5wXb/GlDd3p6NJWiui0mfWQM="
          }, {
            "num_cand": "U2FsdGVkX190eyQ3sb1fa6PNMcx0cdrGpDrvMRTGVrw=",
            "cpf": "U2FsdGVkX18ZOxZLA7J4BsIbImBC97u+giXsMks1EcY="
          }, {
            "num_cand": "U2FsdGVkX1/0l3BP8HGaWcA/qaHChMnMoI98Au4qBmQ=",
            "cpf": "U2FsdGVkX1+Ymutwf142WoTTQOC43FligWs6HI7NQTE="
          }, {
            "num_cand": "U2FsdGVkX1915pDkIE1dQMabrapPuICn4fybciubBis=",
            "cpf": "U2FsdGVkX1/2lKNCGHhZI/VHU771nZAHEB8tta2oMuc="
          }, {
            "num_cand": "U2FsdGVkX1+i9AqLi51ufAywMQVuIw8ZieYvSwmrnWE=",
            "cpf": "U2FsdGVkX1/vnQqEJf2cp89nAj596KrRjo6kLalq8sI="
          }, {
            "num_cand": "U2FsdGVkX18r8E7Yft7zrT3ZG6ogWymelKlMddeCsWo=",
            "cpf": "U2FsdGVkX1//sZOfFLWtvE3aFXt14gkwxXmOXdBpE54="
          }, {
            "num_cand": "U2FsdGVkX19ZYxMKHn7SFuaJYwYPegh01OaypdcGE4I=",
            "cpf": "U2FsdGVkX18CCpuexItpSwJQubMP64YWJItnxuCXkuQ="
          }, {
            "num_cand": "U2FsdGVkX18Jd/PaDauJw2grX8ULxIxlKDq9x6BykXs=",
            "cpf": "U2FsdGVkX1/G2h4dkX2p/zsf6QLe1k0oyOKvw4UsNcA="
          }, {
            "num_cand": "U2FsdGVkX1+trTFPYHFRJ8aZp4y6fgQfxYwh6AUJc0I=",
            "cpf": "U2FsdGVkX1/vJka4/3ztlg55rLFDqORibewSZP6zMd0="
          }, {
            "num_cand": "U2FsdGVkX1/GpcGFp5BVnZotICPVu6Ykp7pFp4+aIu4=",
            "cpf": "U2FsdGVkX1/zH8Z0CYox3o/4W9FVCN3nQj/yFocisy4="
          }, {
            "num_cand": "U2FsdGVkX18qA7Y/uQ9CN5xCwYDYzuXm3WqwZ7hxsNA=",
            "cpf": "U2FsdGVkX19jZ8u2OcnfDh7dpN+ZH0YPnqb/g965I9U="
          }, {
            "num_cand": "U2FsdGVkX19DdI4jrNzCIXbRPUNLZxllfDPCuAU1lgc=",
            "cpf": "U2FsdGVkX1+r/+SDAy4P4GIWYWWRy3bgzOg95+VvmHg="
          }, {
            "num_cand": "U2FsdGVkX1+fDudOk3hjNmoaoP2UQ/1AjUdqKtBTQb8=",
            "cpf": "U2FsdGVkX19rpQsnnXCcSVWdsDAbtkHetBdFeb4jHvo="
          }, {
            "num_cand": "U2FsdGVkX1+z7opKJzdzR9l2QuzvwntpnkGwrZJTiWA=",
            "cpf": "U2FsdGVkX1/aA9Qg/bi7oAjz6cTiBcL642iOLVWKWlQ="
          }, {
            "num_cand": "U2FsdGVkX18LmTryYDPCs6eKLnRj0iy8cPfj0gp3uNA=",
            "cpf": "U2FsdGVkX1/A+ia7ga2GQrkEtQDOcXJ6IXEz4PYW+tA="
          }, {
            "num_cand": "U2FsdGVkX1+KGfw4XWcVihPSh8ooirX8bzGfnKpi1s4=",
            "cpf": "U2FsdGVkX19vCbSpH9DE8RCba1jORjeWuO1h9alwQNY="
          }, {
            "num_cand": "U2FsdGVkX1/ZFdRv3AydpKd3PJzWJkbfRkgZOkU82tg=",
            "cpf": "U2FsdGVkX1+OQ7euUtgSTTe3Zufnk4tafmzswJkczWU="
          }, {
            "num_cand": "U2FsdGVkX19FFCPEzJjCJ1sCsguVJTBXvW05mIkSaIM=",
            "cpf": "U2FsdGVkX180h4P4r6sWsPsTT3f6gc+plBNzU1e35Gw="
          }, {
            "num_cand": "U2FsdGVkX18WCX62TW8FkQcxGwlJ8PboO99fllroSts=",
            "cpf": "U2FsdGVkX180MSr5oK0e7jVEoEwYqBckC7lXIcxKpnk="
          }, {
            "num_cand": "U2FsdGVkX1+AIwC36FibYfJkCdpzDk/wzjaH9BulRME=",
            "cpf": "U2FsdGVkX1/q7xyZlVOXkfqnebvnKoByMc+2NkuTPWA="
          }, {
            "num_cand": "U2FsdGVkX1+u1PmA35vofcg/ZshBxrfvVwzrAtOT+Rc=",
            "cpf": "U2FsdGVkX181qHHkcUgf9Z5sXt/ZZ5vRF15cjnXXW6A="
          }, {
            "num_cand": "U2FsdGVkX1/dbJ5XcbqnPJnECITvNE7o1nZI4cDjpYQ=",
            "cpf": "U2FsdGVkX185/FW4l5Tffj61569eGTl2Gecr8Mfb+xM="
          }, {
            "num_cand": "U2FsdGVkX19btWbcTRZigvUdSWBtJ4dWQoh/0xIwqCU=",
            "cpf": "U2FsdGVkX1+3vHJbWLunQ33fOr/n0kYsU6CkjpMzGUI="
          }, {
            "num_cand": "U2FsdGVkX1+tG1tPG0hMgiNLtNgvdKwyTepZ9rv/rIo=",
            "cpf": "U2FsdGVkX1/HOd7NkIfaoZfqIl9NahkVikgkAsRYHEA="
          }, {
            "num_cand": "U2FsdGVkX1/AgbJPKyEQXnvmEqWTjOeEMIPzxuqdmrM=",
            "cpf": "U2FsdGVkX18WT8kngQTF6WuIu+V6eK68c71ZWyDeATM="
          }, {
            "num_cand": "U2FsdGVkX199H6XtC6ic1cyW+zmUCMx3OJHZHQNg1bY=",
            "cpf": "U2FsdGVkX1/GFiE1PVd9WiOdqjqT4ebxbXq69Uliljo="
          }, {
            "num_cand": "U2FsdGVkX1+hHFIaPTftP/lgct2/qw16b92ApIcfJFE=",
            "cpf": "U2FsdGVkX18XYOhEvFnhXaydifUATmE1zdQYqMDil8E="
          }, {
            "num_cand": "U2FsdGVkX1+5DqNw3FSoCTIQnaaxcPYPDKyFX0o24x0=",
            "cpf": "U2FsdGVkX18t+oCGGo2cpP4sZ6Z2Cgau5PvdUTRbRKE="
          }, {
            "num_cand": "U2FsdGVkX1/361d80ZKWeExtNQikIt0lLOZS46mWl6E=",
            "cpf": "U2FsdGVkX1+Ga0XwuF7aNB/F9ekTl2P/RQ+3+Nu6ySc="
          }, {
            "num_cand": "U2FsdGVkX1+13h6D7mLr8AyFU1uY0CnKTP6ROmoOuxs=",
            "cpf": "U2FsdGVkX189AZmZHGZTX5nAOs4JG0AH5WBtLEgScCw="
          }, {
            "num_cand": "U2FsdGVkX1+ODRwmFdICF97jdl73xFRp4CpOilMQuXA=",
            "cpf": "U2FsdGVkX1+kpt9t9oZmkKNJ4FVQsFWjjsZ/6zgCnjw="
          }, {
            "num_cand": "U2FsdGVkX1+bVPnfLj/uMdnZYqlMZ2WSYcFu4KnWTWM=",
            "cpf": "U2FsdGVkX18qPrvxXAhEAx2lJRqZ5H8ytaychwsqMIo="
          }, {
            "num_cand": "U2FsdGVkX18pbJbXly3p0q6ZcM2Q4sqAsEMegz9i6ls=",
            "cpf": "U2FsdGVkX19gS1fecAP+K4TaQk40J45okAkeb8DbG9s="
          }, {
            "num_cand": "U2FsdGVkX1/2Qw5Mf2zcRhiusvznQD3qebmskt0H09s=",
            "cpf": "U2FsdGVkX1+o0Whr2pdnmB0jhSh4rkflBlgD7OoTKr4="
          }, {
            "num_cand": "U2FsdGVkX18/38bmGqxaG7EPzGNf1T7vzV2fCl3tlqA=",
            "cpf": "U2FsdGVkX1/QBIPfs8J2FHuPo/EW2GtvcWfLj3Pbsyo="
          }, {
            "num_cand": "U2FsdGVkX18B+wfk6v6lRwaLoCnv5veACEAUpWEN/m4=",
            "cpf": "U2FsdGVkX1+3YiDOLT3Ebj4Wn2aQ7YHde/O5vwWcxG0="
          }, {
            "num_cand": "U2FsdGVkX182nC+6llkaIz2s2cqtXuFh2E+IqWzYsQI=",
            "cpf": "U2FsdGVkX19U8X4kDdzy8NrFQpt0bWaYfceS/1uAtpE="
          }, {
            "num_cand": "U2FsdGVkX1+YNyg8pKi/P1rsaimY4TTp4sa8I08CAvw=",
            "cpf": "U2FsdGVkX18P+jEp42szFrlwMv49gHslmFX5fl3+78I="
          }, {
            "num_cand": "U2FsdGVkX1/q/YgtOy7rOgRYdTxGgNzZ43lpEJ7IHoY=",
            "cpf": "U2FsdGVkX19TZOhLbITmSxK4xgmqKxCNHGiVUqMrmEQ="
          }, {
            "num_cand": "U2FsdGVkX18A4tFIKIrFy1FeRp67NH8lkRF3BVxaPLo=",
            "cpf": "U2FsdGVkX18MY5wzSNT+6SEnmTbgv1ocgXzSuxa3upU="
          }, {
            "num_cand": "U2FsdGVkX1/yO4KkAtbCsxUxvwMPZDQGAPCPoHMl4fA=",
            "cpf": "U2FsdGVkX1+Lm7UQJVWjwuSGVOkmzhKHphZw30rdNEo="
          }, {
            "num_cand": "U2FsdGVkX18y6ADG9nHFkxCSgikJmSaI5CqHeASKxgY=",
            "cpf": "U2FsdGVkX18XYdcP3QExthdbfh9yyuMwPL6sX0+l2o8="
          }, {
            "num_cand": "U2FsdGVkX19gUtc7IuXlSBRoobAKGHEcy7W2AkzB7UE=",
            "cpf": "U2FsdGVkX1/sRu350U4X8HzOMkfhKDRbWo9ZCq6xoAg="
          }, {
            "num_cand": "U2FsdGVkX19QTvCevGc3j1f8jpDIy21byIjVIsXD5ps=",
            "cpf": "U2FsdGVkX18tJD4vaK5r4C599ZqoANnt3XG4id1gHXE="
          }, {
            "num_cand": "U2FsdGVkX1+TQsVIM69QzpoeLzM0QhX2/p4Zs/yjXms=",
            "cpf": "U2FsdGVkX1/55yIB6f5p1EEYOPCw1Y3ePVlsM40SRaU="
          }, {
            "num_cand": "U2FsdGVkX1/vrVoILtxSAipikwBcdTJhrDj3hxxDhso=",
            "cpf": "U2FsdGVkX1/VNqBfQXKEZ9ptom9qlVy/kQsrQZSrt+w="
          }, {
            "num_cand": "U2FsdGVkX1+/66oFrZvIpcmlCx5tIDeATEAoqdAqQH4=",
            "cpf": "U2FsdGVkX19OWBq52Zb8StzKGXVFibXH13NdpujAbtk="
          }, {
            "num_cand": "U2FsdGVkX19YbW6cfrXj4jGS6sapNp2SFQOLZji5j+8=",
            "cpf": "U2FsdGVkX18IxJRs6V1y1JE67Vo986wMwoRAME43SOo="
          }, {
            "num_cand": "U2FsdGVkX1/Sl5eyjgtr+iFqH+aVnLhsr5z3uf+O8vs=",
            "cpf": "U2FsdGVkX18YKLeMFCjL3PbUpb0xLg0d4eyzPEP9RkU="
          }, {
            "num_cand": "U2FsdGVkX1/KrpZCrNSexVffqzTTTUTlDrRlocrsj8M=",
            "cpf": "U2FsdGVkX19tmb7mNTioOSbepJh3Lt6LT6uzIiZvjUk="
          }, {
            "num_cand": "U2FsdGVkX19MT0ViRhhZF7wr5kqDdYx0WIZ8XLjPtq0=",
            "cpf": "U2FsdGVkX18O6hdODZHeDBeY75XC2G5GM6CgORfq2WQ="
          }, {
            "num_cand": "U2FsdGVkX18kSYMBUBZEFFhBhqobOMsz4U0IQ2/tSgc=",
            "cpf": "U2FsdGVkX18ZhDdT2x47pYZY9ffBMGkAnTNHBhxcq+U="
          }, {
            "num_cand": "U2FsdGVkX19aslGcZ0pc+Gb3hdBRDAdcqdla1eWdzEU=",
            "cpf": "U2FsdGVkX1/IiyM9QitKvYeTNf25Srzi0XOWYYeqvAg="
          }, {
            "num_cand": "U2FsdGVkX19zrWZ978+esBtg3i/0g/ih7xos6oPXSpM=",
            "cpf": "U2FsdGVkX191byDZpEQQt++/h/ATSxfGhZqXKqUbTDk="
          }, {
            "num_cand": "U2FsdGVkX1+iMAiCH7uBcklGv90JvQXttIWEI5/+Ttw=",
            "cpf": "U2FsdGVkX19Mi8YW0Y42pahxcnkVGEaIpwXAdicCu+w="
          }, {
            "num_cand": "U2FsdGVkX19QwzYLAL10CMYptw/zKC6r167Gottp00g=",
            "cpf": "U2FsdGVkX1/DbbTOCebikHyVw0H/s4ILF7RIM/dVeaE="
          }, {
            "num_cand": "U2FsdGVkX1+ZDVrhYxJhk9wxVZ1PDMcPydzgv7//VSg=",
            "cpf": "U2FsdGVkX19OgX4hdzkEWuoCZevz31SMbRUaYMvDASQ="
          }, {
            "num_cand": "U2FsdGVkX1+34x1149DBXjble2dF+21RLayq0YmXJ/I=",
            "cpf": "U2FsdGVkX18YXb9DGRUF3voLlFZYl3FLc+9HdNExDt4="
          }, {
            "num_cand": "U2FsdGVkX18JejlOh18q+D474v0l8C3Nt6/m8z1ptk8=",
            "cpf": "U2FsdGVkX18Y49YFi1VxeCiMHfhspLEaKAQ4GTIkFFA="
          }, {
            "num_cand": "U2FsdGVkX1+12jkzB4Y6+VmnlsLedMHWnaJnXm4yHeo=",
            "cpf": "U2FsdGVkX18yebgWGqCIhurm2T934xLBViQ18PlgDVk="
          }, {
            "num_cand": "U2FsdGVkX1+H78n6+sSEMGorYUGn7hFdSa1QA/koeY4=",
            "cpf": "U2FsdGVkX18cRp1Xz2jbg3u2Li+1UWDZKKnaN1BmdoY="
          }, {
            "num_cand": "U2FsdGVkX1//GvXV3JGzddIofjQtY1iK/57fl7lHwMY=",
            "cpf": "U2FsdGVkX195SzabAzrH2lvuvlrDwUvNhqBLwArCm3A="
          }, {
            "num_cand": "U2FsdGVkX1+XjmcJYyQhJSZHzbzDnFw50S7py6T3XvQ=",
            "cpf": "U2FsdGVkX1/9rM5vVpY64xvkWfxJ3dB+I6/UcOqsgVU="
          }, {
            "num_cand": "U2FsdGVkX1/L93h4lglIgaYpoLFMdB5fmH17jWXSOyQ=",
            "cpf": "U2FsdGVkX1+xUoo4+oXCubcgS1oYLzGOZ9QJtgZQncI="
          }, {
            "num_cand": "U2FsdGVkX189Pp4b5S5P0d4aQ2UG53HigwUAJKh2xXk=",
            "cpf": "U2FsdGVkX1+UdH1HkyEsP257ov/h7d78TldE3GBcUuQ="
          }, {
            "num_cand": "U2FsdGVkX18dcLAfrMowefSoQACj/V54Zx+tci8df5U=",
            "cpf": "U2FsdGVkX1/I6IkS60TSG/qwjMEDXkl4rvDw+XfUrSM="
          }, {
            "num_cand": "U2FsdGVkX1+IE8otW9ZsoUHvIyZakTRSXmcF8OIhN3w=",
            "cpf": "U2FsdGVkX18wTuDvQ1bQdjA2Dc232tBheJ9BAwHgwd8="
          }, {
            "num_cand": "U2FsdGVkX1+lGY3LU7vFEvsezqqR+TlVpcy8N/PjHe4=",
            "cpf": "U2FsdGVkX1+hmzZPRreLdzIdvHswCCxI7TfehhN/6WI="
          }, {
            "num_cand": "U2FsdGVkX18YJXESI678jsFur7uj1vasBidzgbUdYbA=",
            "cpf": "U2FsdGVkX19mJogI0mk5+h+Owj355EWYfzPhfmeho4U="
          }, {
            "num_cand": "U2FsdGVkX184WMdXJJVsSPfhuj/VJGnAiz+bRwpFf7A=",
            "cpf": "U2FsdGVkX19sSX2YkERuytWibYJgnpbe++3yqHRpTDg="
          }, {
            "num_cand": "U2FsdGVkX18WZSiphC9FgI1MyzN7/TdlajzwQz8nzmw=",
            "cpf": "U2FsdGVkX19Dh93HpdLsiIcHsxUk+iZnQ5fXMahl2rg="
          }, {
            "num_cand": "U2FsdGVkX1/k9Em5TWX2O3G02dnLz6KA2TKouROzGzM=",
            "cpf": "U2FsdGVkX18ZmrLmQ1KeoGMrcA8hNULV7kx7+XFCxNE="
          }, {
            "num_cand": "U2FsdGVkX1+7JzFeRVFhgGYWHmu4ADBLQQ3TsOhakoQ=",
            "cpf": "U2FsdGVkX1+IygTloVg2LUtEqdeSqDutM9I8NFVex1s="
          }, {
            "num_cand": "U2FsdGVkX18mGDVJbu+APXSUW8lnNA+f2EgRX2+zTzU=",
            "cpf": "U2FsdGVkX1+JE9J9wGFTDKWfJFX5wIoo+G1nJf/StnU="
          }, {
            "num_cand": "U2FsdGVkX1++Z6hihnfeG/mbJYJbHdUAXkTr3WiVrRM=",
            "cpf": "U2FsdGVkX1/yocrz4gBJhSBIG87Y2wYfb2Z7J5PoEvA="
          }, {
            "num_cand": "U2FsdGVkX19NlsQe6BrMPqjPkEfiutS0j7UU/Q/4vJ4=",
            "cpf": "U2FsdGVkX1+FGKX4NX1uiKs2eAysNWuDObwZ890CvV8="
          }, {
            "num_cand": "U2FsdGVkX1/WyFVX+1B5pKKtBkTtCOMesHevbYadgLo=",
            "cpf": "U2FsdGVkX18KbPUlq9LxtwWBsPK4+ZuapqbPKt1bww0="
          }, {
            "num_cand": "U2FsdGVkX1/HDG8+ADanFsMkEDYYy6gX5VUME3Ajrvk=",
            "cpf": "U2FsdGVkX1+NXEB5hJmZt2srvw2SK7DjBZvkka9Zuyg="
          }, {
            "num_cand": "U2FsdGVkX1+/+ZLL11vJml112+NgMCChOplqqjiL0Us=",
            "cpf": "U2FsdGVkX19LVq4BcsmsP8r3IZVJANPA/g3lvcbVUDM="
          }, {
            "num_cand": "U2FsdGVkX18OBE3On4slqHbhl2xXtZK0q7gOHgkuTh4=",
            "cpf": "U2FsdGVkX18KhRGGOvu0mQxQaEU0cIfhiJMZPBIEoLA="
          }, {
            "num_cand": "U2FsdGVkX1+Ttf1VB3xbB2QI81X4gofbdk7nxF795s0=",
            "cpf": "U2FsdGVkX18YCXItS/OA51t+MSV9Zd2RkBxdIVQhxmM="
          }, {
            "num_cand": "U2FsdGVkX1/Pn+s7htUJ/IUoOhMgTs4vW1AG2BgqT1g=",
            "cpf": "U2FsdGVkX1/SRddJxkSDWzoXtdwIGqUud8iwMJ4JcQA="
          }, {
            "num_cand": "U2FsdGVkX18pqKnK+WCCDJu75yH1vMcUmPBHIAPVVPg=",
            "cpf": "U2FsdGVkX19J1uI9aw5WSYTdMYZLBc5ZZziCcp0Tros="
          }, {
            "num_cand": "U2FsdGVkX1/HfBVnVUxEESBtyo9y64XEFoe1l1ZXixU=",
            "cpf": "U2FsdGVkX1+G+BR0KdvzXCjqfq26bQCi1vQhC/+fmkU="
          }, {
            "num_cand": "U2FsdGVkX19bVrUmJE+jF8lbrmFEK5JDroFoj9rcySs=",
            "cpf": "U2FsdGVkX192sKCikGra8+E54cdQya+RRYPQFg+q+es="
          }, {
            "num_cand": "U2FsdGVkX18nFKBgEUft7NVdvt+EPd9Xsz/eMfIFGio=",
            "cpf": "U2FsdGVkX199y3QQiJahzFoT/nKZ79nbnY/c7L/QSws="
          }, {
            "num_cand": "U2FsdGVkX19Ei4vs8wxMaIooFKBUIqTJ3uuY+RQDrcg=",
            "cpf": "U2FsdGVkX1/fenUCeEMC2kQJZLXUKq7Yu4Gk2iiijWs="
          }, {
            "num_cand": "U2FsdGVkX18TcP5xjgELHTUt4xZcvTd+/UpOawS9IQc=",
            "cpf": "U2FsdGVkX1+WRX8fWHLtcKuuKEd7Z/Od9pBYsFUublE="
          }, {
            "num_cand": "U2FsdGVkX19S58BFYT1YbWQrzk1UM8m3IyTzaDi9+hs=",
            "cpf": "U2FsdGVkX180I9OoL2d6Gm0gbU8jhGcq/IfnpjRET6M="
          }, {
            "num_cand": "U2FsdGVkX1/HOkOeMEbQEDdTamhuUIVqS31eNfbWB4U=",
            "cpf": "U2FsdGVkX19fe7uhUHiVW1qbdV2smxclf4CL1dSrW8c="
          }, {
            "num_cand": "U2FsdGVkX198WBiZ7tej89KpUiC/ovQJST9U086zk8s=",
            "cpf": "U2FsdGVkX18l4TpNQ01M0opQBGMsK2v62m1P/eDAi5Q="
          }, {
            "num_cand": "U2FsdGVkX1+zI1WOR5ctECHWu7Wf+KvnveSjZb9macM=",
            "cpf": "U2FsdGVkX18Rzu30pGe8O799JZbh9/cUgCAnugx/jTA="
          }, {
            "num_cand": "U2FsdGVkX181cw0vHgxIqRbbS7e7ws5FWlZxwP6LWNw=",
            "cpf": "U2FsdGVkX1/YhW1eXBqCmR8ngYIymzMMksJuADQmFUg="
          }, {
            "num_cand": "U2FsdGVkX1/gSrhlFqLS3pfzW6kIQm4WRKcHZMYaEF0=",
            "cpf": "U2FsdGVkX1/YDSfGz+gmRiQZ2wyOVAJ2aZO7rkn+RMQ="
          }, {
            "num_cand": "U2FsdGVkX18TM3CWk2tJOVakei+e27U40yCI3NQvwuY=",
            "cpf": "U2FsdGVkX18kjhNlIr2G5kTt/XFvuBPAK1OkmHsIWZo="
          }, {
            "num_cand": "U2FsdGVkX180IKZ9X4emjpJ3UOb5on9i5TPvrA12T2U=",
            "cpf": "U2FsdGVkX19PMwFlieMXM06Uu0BPafCJrX9H/eVEOCU="
          }, {
            "num_cand": "U2FsdGVkX19PShcIulvPJhCV4ioDlZ3FzvXxSr+rHp8=",
            "cpf": "U2FsdGVkX19HuMRJHPnSQb9c0lYICu7VHAXGjT9u8Nc="
          }, {
            "num_cand": "U2FsdGVkX18pirkniRQ/36ZF1nJg/52utxIPnjEI/PU=",
            "cpf": "U2FsdGVkX18uy+hwwl+C1ynmI08s+qI2iRJ/EMOQzi8="
          }, {
            "num_cand": "U2FsdGVkX1/4ZPfgN38ryZOqT5FtNllDJA1GfPI9PXc=",
            "cpf": "U2FsdGVkX19KYZgPCY3Ij5Q5XaIOtC73VZ7EVzglXbU="
          }, {
            "num_cand": "U2FsdGVkX18Yp8XcpyfIB+qsnrizsUgr3Xi0iCpwSUM=",
            "cpf": "U2FsdGVkX1+9aY6IiHvTnmJuGnMSkUpYaNPdEK1HGRs="
          }, {
            "num_cand": "U2FsdGVkX1/ZYI1syteQjSUYeTMOn2uzKMvf9QzeJQg=",
            "cpf": "U2FsdGVkX19Ge1mm3A8TNxw9vhR6gxyKmAjXgap0wgw="
          }, {
            "num_cand": "U2FsdGVkX1+lIg4FAl2tAPBbwNkbWAGBX2nzlJr18UI=",
            "cpf": "U2FsdGVkX1+KNwQEIDxOpvsBtQGD3zRM5P+2cRC5maQ="
          }, {
            "num_cand": "U2FsdGVkX1+YsYlULMkL1Ex+5r8CQlpPFIou/2VCZHU=",
            "cpf": "U2FsdGVkX19kJhWznTJkrnKDPc041TfiYr6INhFHVjg="
          }, {
            "num_cand": "U2FsdGVkX1/s+ti6+e9mXYqq4OQN3oo63nv4MS8f6F4=",
            "cpf": "U2FsdGVkX18pelHT94TZqwmXnjvzTPbLxD7WCTCUT7I="
          }, {
            "num_cand": "U2FsdGVkX1+rXOYdkvrxjL9E3JERIe+b0MOIZy5zrW4=",
            "cpf": "U2FsdGVkX1+RIQox0lGUSFnxup5sLxPSn4f1CtLOijA="
          }, {
            "num_cand": "U2FsdGVkX18v4nO16tWpFK+tTP49yCxHBi1lblCH2sw=",
            "cpf": "U2FsdGVkX1/fgDDLXyP+QpiCSX0HTtKMt9l0At45vrQ="
          }, {
            "num_cand": "U2FsdGVkX1+4S5HREzwjbVZZNtW6nLKPn2QQVpgdkuc=",
            "cpf": "U2FsdGVkX1+mXLH3WQJFP8X02pDO/jcUhlYKHcwir1o="
          }, {
            "num_cand": "U2FsdGVkX18a/ifL+bwXNlIhC3AZU/RKRsTlTuBbRdQ=",
            "cpf": "U2FsdGVkX186uBGwNLnfUTWGiOCTL2eM+221iIdAPhQ="
          }, {
            "num_cand": "U2FsdGVkX1+OSI65FSN7yFSVNgb6tlmZPUiX6gBfbvo=",
            "cpf": "U2FsdGVkX19eOEPp2hKr0j2C/T/3vWeXvoTIex1Sn8M="
          }, {
            "num_cand": "U2FsdGVkX18uIh6aw/6lIYyyhGe/bcaRF3YtEhAK8jc=",
            "cpf": "U2FsdGVkX19uzUfbUKb3SwgnlVrUiGUkxVqZO5P/dRc="
          }, {
            "num_cand": "U2FsdGVkX1+ebrMVFPgTS/JHJXZvY2RB3XAjj7zqZNg=",
            "cpf": "U2FsdGVkX1/7Yux+zNHUyab10ZdEBYJLaI8EcpQ/NU0="
          }, {
            "num_cand": "U2FsdGVkX19hTRfUNiv4Zn2prDgoxL2BoO84g1yzNfU=",
            "cpf": "U2FsdGVkX1+KS2YXEs1yav/KLc4kJ/9YQMEl8VyamLM="
          }, {
            "num_cand": "U2FsdGVkX19AhLG3IjOAHI2wkXjd0BBhcJo5vsR+e3o=",
            "cpf": "U2FsdGVkX1/SBoKAbeZl0INhq48PcoBplRniGbrzzlA="
          }, {
            "num_cand": "U2FsdGVkX1/68FCHl2jW8LffZb1ofxFGTepaaiSWM1Q=",
            "cpf": "U2FsdGVkX19dp95gk94l70Gl7fOmlhqIIfcy/K1u69Q="
          }, {
            "num_cand": "U2FsdGVkX19W0TZOLT+45szE7TF+k86nGJpsgoEiuWE=",
            "cpf": "U2FsdGVkX1+rAAtn36JbGDn+5NJRuK96BBkQv1LIgNQ="
          }, {
            "num_cand": "U2FsdGVkX19L2fvaQ37U+PLB1uqzLQwn2ciFKxmFCts=",
            "cpf": "U2FsdGVkX18CpjorSKgN4+IPsuGGMg6FdprZSoFhR6E="
          }, {
            "num_cand": "U2FsdGVkX19uwZeLMjAaHDkfBdHMrvXYwBn/83LDRKA=",
            "cpf": "U2FsdGVkX1/ncCszrPrjY559p8FEvSyGdSwf1miyFgo="
          }, {
            "num_cand": "U2FsdGVkX18Z3mS4WAQR5F5L+98Yegwscv0avgNF3D8=",
            "cpf": "U2FsdGVkX18gqoEyaN3jPSd++BbnzB0U23B8uZ2W1iI="
          }]


      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2208/rec_gbb/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
